import { useParams } from "react-router-dom";
import {
  useCreateShareLinkMutation,
  useDeleteConversationMutation,
  useGetConversationHistoryInfiniteQuery,
  useGetQuestionsBySessionIdInfiniteQuery,
  useLazyGetShareLinkQuery,
  usePinConversationMutation,
  useRenameConversationMutation,
  useRevokeShareLinkMutation,
} from "@/services/(company)/api.ai-assistant";
import {
  ConversationsHistory,
  type ConversationHistoryApi,
} from "@/components/ai-assistant/conversation-history";
import { COMPANY_AI_ASSISTANT_SESSION_ID_KEY } from "@/routes/company/routes.ai-assistant";

const api: ConversationHistoryApi = {
  useConversations: useGetConversationHistoryInfiniteQuery,
  useQuestionsBySession: useGetQuestionsBySessionIdInfiniteQuery,
  usePinConversation: usePinConversationMutation,
  useRenameConversation: useRenameConversationMutation,
  useDeleteConversation: useDeleteConversationMutation,
  useLazyGetShareLink: useLazyGetShareLinkQuery,
  useCreateShareLink: useCreateShareLinkMutation,
  useRevokeShareLink: useRevokeShareLinkMutation,
};

export const CompanyConversationsHistory = () => {
  const { [COMPANY_AI_ASSISTANT_SESSION_ID_KEY]: activeSessionId } = useParams();
  return <ConversationsHistory api={api} activeSessionId={activeSessionId} />;
};
